{% import Spinner from 'shared/components/spinner/spinner.monk' %}

<div class="pagination_button" role="pagination_button">
  <div class="pagination_button-text"> {{ button_text }} </div>
  <div class="pagination_button-spinner">
    <Spinner />
  </div>
</div>
